<a [storyblokLink]="link" [appStoryblok]="_editable">
  {{ text }}
</a>
